import * as Api from '@ViewModels';
import { useInfiniteQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

const INTEGRATIONS_ACTIVITIES_FILTER_QUERY_KEY = 'integrations/activities/filter';

export function useInfiniteExternalIntegrationActivities({
	enabled = true,
	filterRequest,
	impersonationContext,
	integrationProvider,
	pageSize = 100,
	refetchOnWindowFocus = false,
}: {
	enabled?: boolean;
	filterRequest: Api.IntegrationActivitiesFilterRequest;
	impersonationContext?: Api.IImpersonationContext;
	integrationProvider: Api.IntegrationProvider;
	pageSize?: number;
	refetchOnWindowFocus?: boolean;
}) {
	const userSession = useUserSession();

	return useInfiniteQuery<Api.IPagedCollection<Api.ProcessedStatsTypes>>({
		enabled,
		getNextPageParam: lastPage => lastPage.pageToken,
		queryFn: ({ pageParam }) => {
			return userSession.webServiceHelper.callAsync<Api.IPagedCollection<Api.ProcessedStatsTypes>>(
				Api.ImpersonationBroker.composeApiUrl({
					impersonationContext,
					queryParams: { pageSize, pageToken: pageParam },
					urlPath: `integrations/${integrationProvider}/activities/filter`,
				}),
				'POST',
				filterRequest
			);
		},
		queryKey: [
			INTEGRATIONS_ACTIVITIES_FILTER_QUERY_KEY,
			integrationProvider,
			filterRequest,
			pageSize,
			impersonationContext,
		],
		refetchOnWindowFocus,
		initialPageParam: '',
	});
}
